import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { mediaUrl } from "../lib/api";
import { iconFor } from "../lib/categories";

export default function ListingCard({ listing }) {
  const Icon = iconFor(listing.category);
  const cover = listing.photos?.[0];
  return (
    <Link to={`/b/${listing.id}`} data-testid={`listing-card-${listing.id}`}
      className="group bg-white border border-zinc-200 rounded-lg overflow-hidden hover-lift flex flex-col">
      <div className="relative aspect-[16/10] bg-zinc-100 overflow-hidden">
        {listing.active_offer && (
          <span className="absolute top-3 left-3 z-10 px-2.5 py-1 rounded-md bg-[#FFCC00] text-black text-xs font-bold font-display" data-testid={`offer-badge-${listing.id}`}>
            Offer{listing.active_offer.label ? ` · ${listing.active_offer.label}` : ""}
          </span>
        )}
        {cover ? (
          <img src={mediaUrl(cover)} alt={listing.business_name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-zinc-100">
            <Icon className="w-10 h-10 text-zinc-400" />
          </div>
        )}
      </div>
      <div className="p-5 flex-1 flex flex-col">
        <span className="inline-flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-widest text-zinc-500 mb-2">
          <Icon className="w-3 h-3" /> {listing.category}
        </span>
        <p className="font-display text-xl font-bold leading-tight">{listing.business_name}</p>
        {listing.tagline && <p className="text-sm text-zinc-600 mt-1 line-clamp-2">{listing.tagline}</p>}
        <p className="mt-auto pt-4 text-xs text-zinc-500 flex items-center gap-1">
          <MapPin className="w-3 h-3" /> {listing.town} · {listing.postcode}
        </p>
      </div>
    </Link>
  );
}
